import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/axiosConfig';
import { useAuth } from '../context/AuthContext';
import '../styles/ContactPage.css';

export default function ContactPage() {
  const { account, isSuperAdmin } = useAuth();
  const [type, setType] = useState('issue');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || message.trim().length < 5) {
      return toast.error('يرجى كتابة تفاصيل أوضح');
    }
    setSubmitting(true);
    try {
      const { data } = await api.post('/backoffice/contact', {
        type,
        message: message.trim(),
      });
      if (data.success) {
        toast.success(data.message);
        setMessage('');
      } else {
        toast.error(data.message || 'حدث خطأ');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'تعذر إرسال الرسالة');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bo-contact-page">
      <div className="bo-contact-header">
        <h1>تواصل معنا</h1>
        <p>
          للإبلاغ عن مشكلة أو طلب ميزة. تصل الرسالة إلى{' '}
          <span dir="ltr">admin@adwary.app</span>
          {isSuperAdmin
            ? ' مع تمييز أنها من المدير العام.'
            : account?.title
              ? ` مع اسم نشاطك: ${account.title}`
              : ' مع بيانات حسابك.'}
        </p>
      </div>

      <form className="bo-contact-form" onSubmit={handleSubmit}>
        {!isSuperAdmin && account && (
          <div className="bo-contact-business">
            <strong>النشاط:</strong> {account.title}
            {account.phone ? (
              <span dir="ltr"> · {account.phone}</span>
            ) : null}
          </div>
        )}

        <label htmlFor="bo-contact-type">نوع الرسالة</label>
        <select
          id="bo-contact-type"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="issue">مشكلة / استفسار</option>
          <option value="feature">طلب ميزة جديدة</option>
        </select>

        <label htmlFor="bo-contact-message">الرسالة</label>
        <textarea
          id="bo-contact-message"
          rows={7}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="اكتب تفاصيل المشكلة أو الميزة المطلوبة..."
          required
        />

        <button type="submit" className="bo-contact-submit" disabled={submitting}>
          {submitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
        </button>
      </form>
    </div>
  );
}
